export default {
  APP: {
    MOUNT: 'APP.MOUNT',
    RESIZE: 'APP.RESIZE',
  },
  DISCLAIMER: {
    OPENDISCLAIMER: 'DISCLAIMER.OPENDISCLAIMER',
    CLOSEDISCLAIMER: 'DISCLAIMER.CLOSEDISCLAIMER',
  },
  DATA: {
    DATA_LOADED: 'DATA.DATA_LOADED',
  },
  BANNER: {
    BUTTON_CLICK: 'BANNER_CTA.BUTTON_CLICK',
  },
  CARD: {
    VIEW_SPECIAL_OFFER_DETAIL: 'CARD.VIEW_SPECIAL_OFFER_DETAIL',
    VIEW_OFFER_DETAIL: 'CARD.VIEW_OFFER_DETAIL',
  },
  TABS: {
    SELECT: 'TABS.SELECT',
  },
  ZIPCODE: {
    UPDATE: 'ZIPCODE.UPDATE',
  },
  RAQ: {
    OPEN: 'RAQ.OPEN',
  },
  OFFER_CARD: {
    BUTTON_CLICK: 'OFFER_CARD.BUTTON_CLICK',
    LINK_CLICK: 'OFFER_CARD.LINK_CLICK',
  },
  CTA: {
    CLICK: 'CTA.CTA_CLICK',
  },
  MODAL: {
    MODAL_OPEN: 'MODAL.MODAL_OPEN',
    MODAL_LOADED: 'MODAL.MODAL_LOADED',
    MODAL_CLOSE: 'MODAL.MODAL_CLOSE',
    MODAL_IS_CLOSING: 'MODAL.MODAL_IS_CLOSING',
    MODAL_OPEN_RAQ: 'MODAL.MODAL_OPEN_RAQ',
  },
  ZIPGATE: {
    OPEN: 'ZIPGATE.OPEN',
    CLOSE: 'ZIPGATE.CLOSE',
  },
  MODEL: {
    CHANGE: 'DROPDOWN.CHANGE',
  },
  LEASE: {
    LEASE_PAYMENT_CHANGE: 'LEASE.LEASE_PAYMENT_CHANGE',
  },
};
